export default __webpack_public_path__ + "static/11-247fa23779c90ceb214f57f2b066f40b.jpg";